import { useCallback, useEffect, useState } from "react";
import { X } from "lucide-react";
import { EditorModal } from "@/components/EditorModal";
import { ClearancePacketActions } from "@/components/compliance/ClearancePacketActions";
import { api, formatApiError } from "@/lib/api";

const ACTION_LABEL = { generated: "Generated", downloaded: "Downloaded", sent_to_portal: "Sent to client portal" };

export const ClearancePacketLog = ({ provider, onClose }) => {
  const [data, setData] = useState({ packets: [], events: [], assignments: [] });
  const [error, setError] = useState("");

  const load = useCallback(() => {
    api.get("/compliance/clearance-packets", { params: { provider_id: provider.id } })
      .then((response) => setData(response.data))
      .catch((requestError) => setError(formatApiError(requestError)));
  }, [provider.id]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <EditorModal onClose={onClose} testId="clearance-packet-log-modal">
      <section className="inline-edit-panel clearance-packet-log" data-testid={`clearance-packet-log-${provider.id}`}>
        <div className="section-heading">
          <div>
            <h2>Clearance packets · {provider.first_name} {provider.last_name}</h2>
            <p>Generate a packet per client assignment. Every generation, download and client-portal send is logged with the user and time.</p>
          </div>
          <button className="projection-icon-button" data-testid="close-clearance-packet-log" type="button" onClick={onClose}><X size={16} /></button>
        </div>
        {error && <p className="form-message error-message">{error}</p>}
        {data.assignments?.length ? data.assignments.map((assignment) => (
          <ClearancePacketActions key={assignment.id} assignment={assignment} onChange={load} />
        )) : <p className="operations-empty-state" data-testid="clearance-packet-no-assignments">This provider has no client assignment yet. Record an assignment first; packets are generated per client.</p>}
        <div className="credential-table-wrap">
          <table data-testid="clearance-packet-events">
            <thead><tr><th>When</th><th>Action</th><th>User</th><th>Client</th></tr></thead>
            <tbody>
              {data.events.map((event) => (
                <tr key={event.id} data-testid={`packet-event-${event.id}`}>
                  <td>{new Date(event.occurred_at).toLocaleString()}</td>
                  <td>{ACTION_LABEL[event.action] || event.action}</td>
                  <td>{event.actor_name}<span>{event.actor_role.replaceAll("_", " ")}</span></td>
                  <td>{event.client_name}</td>
                </tr>
              ))}
              {!data.events.length && <tr><td colSpan={4}>No activity yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>
    </EditorModal>
  );
};
